export function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
export const highlightTitleWords = (title) => title.replaceAll(/\*([\w\W]+)\*/g, '<span>$1</span>');
/**
 * Rule structure for react-hook-form
 */
export const EMAIL_RULE = {
    message: `Please enter a valid email address`,
    value: /^[\w\-_.\d*]+@[\w\-\d.]+(\.\w*)$/,
};
/**
 * Rule structure for react-hook-form
 */
export const PHONE_NUMBER_RULE = {
    message: `Please enter a valid phone number`,
    value: /^[\d+()\-x ]+$/,
};
/**
 * Rule structure for react-hook-form
 */
export const NAME_RULE = {
    message: `Please enter a valid name`,
    value: /^[A-Za-z\u00C0-\u1EFF'\-,.]{2,}$/,
};
/**
 * (?=.*[a-z])        = Check for lowercase letter
 * (?=.*[A-Z])        = Check for uppercase letter
 * (?=.*[^\da-zA-Z])  = Check for non-digit and non-letter (^ negates the [] section)
 * .{8,}              = Make sure it is at least 8 characters, no maximum
 */
export const PASSWORD_RULE_REGEX = /^(?=.*[A-Z])(?=.*[\W])(?=.*[a-z])(?=.*[^\da-zA-Z]).{8,}$/;
/**
 * Rule structure for react-hook-form
 */
export const PASSWORD_RULE = {
    message: `Please enter a valid password`,
    value: PASSWORD_RULE_REGEX,
};
/**
 * Set of rules to keep the wording consistant throughout the site.
 */
export const PASSWORD_RULES = [
    'At least 8 characters long',
    'At least one Uppercase letter A-Z',
    'At least one Lowercase letter a-z',
    'At least one special character (~!@#$%^&*_-+=`|(){}[]:;”’<>,.?/)',
];
/**
 * Rule structure for react-hook-form
 * Pattern based on https://andrewwburns.com/2018/04/10/uk-postcode-validation-regex/, but allows both lower and uppercase
 */
export const POSTCODE_RULE = {
    message: `Please enter a valid postcode`,
    value: /^(([A-Za-z][0-9]{1,2})|(([A-Za-z][A-HJ-Ya-hj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-HJ-Ya-hj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2}$/,
};
/**
 * Rule structure for react-hook-form
 * Pattern based on https://regexr.com/39nr7
 */
export const URL_RULE = {
    message: `Please enter a valid URL`,
    value: /[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/,
};
/** Clamp index to be within the min/max index range. */
export function clamp(value, max) {
    return Math.max(Math.min(value, max), 0);
}
/** Ensure input value isn't just whitespace */
export const validateNotWhitespaceOnly = (value) => typeof value === 'string'
    ? value.trim().length > 0 || 'Inputted value cannot just be spaces'
    : true;
/**
 * Trim trailing whitespace from string values in form submission data.
 * Password fields are skipped, as trailing whitespace may be an intentional part of the password.
 */
export function trimTrailingWhitespace(data) {
    const result = { ...data };
    for (const key of Object.keys(result)) {
        const value = result[key];
        if (typeof value === 'string' && !/password/i.test(key)) {
            result[key] = value.replace(/\s+$/, '');
        }
    }
    return result;
}
export function youTubeIdParser(url) {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[7].length == 11 ? match[7] : '';
}
export async function checkYoutubeImageExists(imageSrc) {
    const res = await fetch(imageSrc);
    if (!res.ok) {
        console.log('failed');
    }
    else {
        console.log('success');
    }
    return Promise.resolve();
}
export function linkAria(linkText, linkTarget, string) {
    if (linkTarget !== '_blank') {
        return linkText;
    }
    return `(${string ?? 'Opens in a new tab'}) ${linkText}`;
}
